import {
  Box,
  Collapse,
  FormControlLabel,
  Radio,
  Stack,
  Typography,
} from "@mui/material";
import type React from "react";
import { useEffect, useRef, useState } from "react";
import type { DeliveryType } from "../organisation-repurchase-delivery-page";

export const RadioDeliveryOption = ({
  value,
  label,
  selected,
  children,
}: {
  value: DeliveryType;
  label: string;
  selected: boolean;
  children?: React.ReactNode;
}) => {
  const radioRef = useRef<HTMLButtonElement | null>(null);
  const [radioWidth, setRadioWidth] = useState<number | null>(null);

  useEffect(() => {
    if (radioRef.current) {
      setRadioWidth(radioRef.current.getBoundingClientRect().width - 9);
    }
  }, []);

  return (
    <>
      <FormControlLabel
        sx={{ ...(selected && { alignItems: "flex-start", pt: 1 }) }}
        value={value}
        control={<Radio ref={radioRef} sx={{ ...(selected && { pt: 0 }) }} />}
        componentsProps={{ typography: { flex: 1 } }}
        label={
          <Stack spacing={2}>
            <Typography variant={"body1"}>{label}</Typography>
          </Stack>
        }
      />
      {radioWidth !== null && (
        <Collapse in={selected}>
          <Box sx={{ ml: `${radioWidth}px`, pt: 2, pb: 4 }}>{children}</Box>
        </Collapse>
      )}
    </>
  );
};
